<template>
  <div class="page-container">
    <div class="filter-right-container">
      <div class="page-title">
        {{ $t('menu.notifications') }}
      </div>
      <el-popover
        placement="bottom"
        trigger="click"
      >
        <div class="filter-section-container">
          <div id="filter-content" class="filter-content">
            <div class="filter-item">
              <div class="filter-item-label">
                {{ $t('no_auth.notification_time') }}
              </div>
              <el-date-picker
                v-model="search.notice_time"
                class="picker filter-item-value"
                size="small"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                type="daterange"
                range-separator="~"
                :start-placeholder="$t('components.start_date')"
                :end-placeholder="$t('components.end_date')"
              />
            </div>
            <div class="filter-item">
              <div class="filter-item-label">{{ $t('no_auth.type') }}</div>
              <el-select v-model="search.template_type" :placeholder="$t('no_auth.type')" size="small" class="filter-item-value" clearable>
                <el-option
                  v-for="item in templateTypeList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </div>
            <div class="filter-item">
              <div class="filter-item-label">{{ $t('no_auth.subject') }}</div>
              <el-input v-model="search.title" :placeholder="$t('no_auth.subject')" size="small" class="filter-item-value" clearable />
            </div>
          </div>
          <div class="filter-operate">
            <div class="filter-operate-right">
              <el-button class="search-btn mb-10" @click="resetSearch">{{ $t('components.clear') }}</el-button>
              <el-button class="search-btn" type="primary" icon="el-icon-search" @click="handleSearch">{{ $t('components.search') }}</el-button>
            </div>

          </div>
        </div>
        <el-button slot="reference" class="mb-10 mr-12" type="info" plain>   <svg-icon class-name="mr-10" icon-class="filter" />{{ $t('components.filter') }}</el-button>
      </el-popover>
    </div>

    <!-- Tabs for Unread/All -->
    <div class="tabs-container">
      <div class="tabs-left">
        <div
          class="tab-item"
          :class="{ active: activeTab === 'unread' }"
          @click="onTabChange('unread')"
        >
          {{ $t('no_auth.unread') }}
        </div>
        <div
          class="tab-item"
          :class="{ active: activeTab === 'all' }"
          @click="onTabChange('all')"
        >
          {{ $t('no_auth.all') }}
        </div>
      </div>
      <div class="tabs-right">
        <el-button
          v-if="isAgentMerchant"
          type="success"
          size="small"
          @click="showNotificationConfigModal"
        >
          {{ $t('system.notification_config') }}
        </el-button>
        <el-button
          type="primary"
          size="small"
          @click="onClickMarkAllAsRead"
        >
          {{ $t('no_auth.mark_all_read', { count: $store.getters.unreadNotificaionCount }) }}
        </el-button>
      </div>
    </div>

    <div class="tableContainer">
      <el-table
        v-loading="listLoading"
        :data="tableData"
        stripe
        fit
        highlight-current-row
        style="width: 100%"
      >

        <el-table-column :label="$t('no_auth.subject')" align="center">
          <template slot-scope="scope">
            <el-tooltip :content="scope.row.title" placement="top" :disabled="!scope.row.title">
              <div class="title-cell">
                <span v-if="scope.row.user_read_status === 1" class="dot" />
                <span class="title-text">{{ scope.row.title }}</span>
              </div>
            </el-tooltip>
          </template>
        </el-table-column>

        <el-table-column :label="$t('no_auth.type')" align="center">
          <template slot-scope="scope">
            {{ getTemplateTypeLabel(scope.row.template_type) }}
          </template>
        </el-table-column>

        <el-table-column :label="$t('no_auth.notification_time')" align="center">
          <template slot-scope="scope">
            {{ scope.row.notice_actual_time }}
          </template>
        </el-table-column>

        <el-table-column :label="$t('components.operation')" align="center">
          <template slot-scope="scope">
            <el-tooltip placement="top">
              <div slot="content">
                <span> {{ $t('components.detail') }}</span> <br>
              </div>
              <svg-icon class-name="icon-function" icon-class="operation-detail" @click="onClickDetailBtn(scope.row)" />
            </el-tooltip>
            <!-- <svg-icon class-name="icon-function mb-10" icon-class="operation-delete" @click="onClickDeleteBtn(scope.row)" /> -->
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-container">
        <paginator v-if="!listLoading" :list-query="listQuery" @paginator-change="onClickPaginator" />
      </div>
    </div>

    <NotificationConfigModalGlobal />
  </div>
</template>

<script>
import { fetchNotificationPageAll, deleteMchUserNotification, markNoticeAsRead } from '@/api/system/system'
// import { strAesDecryptAndAsterisk, strAesDecryptAndEmailAsterisk } from '@/utils/encrypt'

export default {
  name: 'System_User_List',
  components: {
    Paginator: () => import('@/views/components/Paginator'),
    NotificationConfigModalGlobal: () => import('@/views/paycools/system/components/Modal/NotificationConfigModalGlobal.vue')
  },
  data() {
    return {
      search: {
        notice_time: [],
        template_type: ''
      },
      tableData: [],
      listLoading: false,
      listQuery: {
        page: 1,
        limit: 15,
        total: 0
      },
      userId: 0,
      activeTab: 'unread' // Default to unread tab
    }
  },
  computed: {
    isAgentMerchant() {
      return this.$store.getters.isAgentMerchant
    },
    readFlagList() {
      const list = [
        {
          label: this.$t('map.read_flag_1'),
          value: 1
        },
        {
          label: this.$t('map.read_flag_2'),
          value: 2
        }
      ]
      return list
    },
    findReadFlag() {
      return function(value) {
        const i = this.readFlagList.find(item => item.value === value)
        return i || {}
      }
    },
    templateTypeList() {
      return [
        { value: 1, label: this.$t('map.template_type_1') },
        { value: 2, label: this.$t('map.template_type_2') },
        { value: 3, label: this.$t('map.template_type_3') },
        { value: 4, label: this.$t('map.template_type_4') },
        { value: 5, label: this.$t('map.template_type_5') },
        // { value: 6, label: this.$t('map.template_type_6') },
        { value: 99, label: this.$t('map.template_type_99') }
      ]
    }
  },
  mounted() {
    this.handleSearch()
  },
  methods: {
    getTemplateTypeLabel(type) {
      const typeMap = {
        1: this.$t('map.template_type_1'),
        2: this.$t('map.template_type_2'),
        3: this.$t('map.template_type_3'),
        4: this.$t('map.template_type_4'),
        5: this.$t('map.template_type_5'),
        // 6: this.$t('map.template_type_6'),
        99: this.$t('map.template_type_99')
      }
      return typeMap[type] || type
    },
    onTabChange(tab) {
      this.activeTab = tab
      this.listQuery.page = 1
      this.getMessageList()
    },
    handleSearch() {
      this.listQuery.page = 1
      this.getMessageList()
      this.$store.dispatch('user/getUnreadNotificationCount')
    },
    resetSearch() {
      this.search = {
        notice_time: [],
        template_type: ''
      }
      this.listQuery.page = 1
      this.getMessageList()
    },
    onClickPaginator(payload) {
      if (payload) {
        if (payload.limit !== undefined) this.listQuery.limit = payload.limit
        if (payload.page !== undefined) this.listQuery.page = payload.page
      }
      this.getMessageList()
    },
    getParams(otherParams = {}) {
      const { notice_time = [], ...otherSearch } = this.search
      let params = { ...otherSearch, ...otherParams }

      // Add user_read_status based on active tab
      if (this.activeTab === 'unread') {
        params.user_read_status = 1 // 1 for unread
      }
      // If 'all', don't pass user_read_status to get all notifications

      if (Array.isArray(notice_time) && notice_time.length > 0) {
        params.notice_actual_time_start = notice_time[0] + ' 00:00:00'
        params.notice_actual_time_end = notice_time[1] + ' 23:59:59'
      }
      params.page = this.listQuery.page
      params.limit = this.listQuery.limit

      params = this.$commonFn.filterEmptyAttr(params)
      return params
    },
    getMessageList(otherParams = {}) {
      this.listLoading = true
      const params = this.getParams(otherParams)
      fetchNotificationPageAll(params).then(res => {
        if (res.code === 10000) {
          const { total, list = [] } = res.data || {}
          this.tableData = list
          this.listQuery.total = total
          this.listQuery.page = params.page ? params.page : 1
        }
      }).finally(() => {
        this.listLoading = false
      })
    },
    onClickDetailBtn(item) {
      this.$router.push({
        name: 'Notification_Detail',
        params: { user_detail_no: item.user_detail_no }
      })
    },
    onClickMarkAllAsRead() {
      markNoticeAsRead({}).then(res => {
        if (res.code === 10000) {
          this.$message.success('Success')
          this.$store.dispatch('user/getUnreadNotificationCount')
          this.getMessageList()
        }
      })
    },
    onClickDeleteBtn(row) {
      this.$confirm('Whether to delete', 'Tips', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        const params = {
          user_detail_no: row.user_detail_no
        }
        deleteMchUserNotification(params).then(res => {
          if (res.code === 10000) {
            this.$message.success('Success')
            this.getMessageList()
          }
        })
      })
    },
    showNotificationConfigModal() {
      const userInfo = this.$store.getters.userInfo
      // const merchant = userInfo?.merchant || {}
      // const mechantId = merchant.id

      const username = userInfo.user_name
      const email = userInfo.email

      // if (process.env.NODE_ENV === 'production' && mechantId === 31) {
      //   username = strAesDecryptAndAsterisk(userInfo.username)
      //   email = strAesDecryptAndEmailAsterisk(userInfo.email)
      // }

      // if (process.env.NODE_ENV === 'development' && mechantId === 7) {
      //   username = strAesDecryptAndAsterisk(userInfo.username)
      //   email = strAesDecryptAndEmailAsterisk(userInfo.email)
      // }

      const row = {
        id: userInfo.user_id,
        username: username,
        email: email,
        account_type: userInfo.account_type
      }

      this.$bus.emit('SHOW_NOTIFICATION_CONFIG_MODAL', [true, row])
    }
  }
}
</script>

<style scoped>
.filter-right-container{
  display: flex;
  justify-content: space-between;
}
.page-title{
  padding-bottom: 0;
}
.dot{
  display: inline-block;
  width: 10px;
  height: 10px;
  background: #3855F1;
  border-radius: 50%;
  margin-right: 5px;
  flex-shrink: 0;
}
.title-cell{
  display: flex;
  align-items: center;
  justify-content: flex-start;
  overflow: hidden;
}
.title-text{
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
  .system-user-list{
    margin: 48px;
    background-color: #fff;
  }
.tabs-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #E3E3E3;
  margin-bottom: 16px;
}
.tabs-left {
  display: flex;
}
.tabs-right {
  display: flex;
  gap: 8px;
}
.tab-item {
  padding: 12px 24px;
  cursor: pointer;
  color: #606266;
  font-size: 14px;
  position: relative;
  transition: all 0.3s;
}
.tab-item.active {
  color: #3855F1;
  font-weight: 500;
}
.tab-item.active::after {
  content: '';
  position: absolute;
  bottom: -1px;
  left: 0;
  right: 0;
  height: 2px;
  background: #3855F1;
}
  .filter-container{
    text-align: right;
    padding: 0 24px 24px;
  }
  .search-frame {
    width: 160px;
    margin-left: 5px;
  }
  .search-btn {
    margin-left: 10px;
  }
  .transTime{
    display: inline-block;
    padding: 0 20px 10px 0;
    font-size: 14px;
    font-weight: 500;  font-family: 'Inter-Medium';
    color: #606266;
  }
</style>
